module.exports = __webpack_public_path__ + "723494a45f26bb1427c6d43205333ff1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/imgs/flags.png
 ** module id = 1042
 ** module chunks = 0
 **/